<script lang="ts">
	import { t } from 'svelte-i18n';
	import { urls } from '../../../urls';
	import MainNavItemWithDropdown from './MainNavItemWithDropdown.svelte';
	import { ButtonText } from '@wiseed/wikit';
	import type { ComponentType } from '@wiseed/wikit';
	import { page } from '$app/stores';

	export let props = {};

	let items: ComponentType[];

	$: items = [
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.header.about.ourMission'),
					href: urls.ABOUT.OUR_MISSION,
					classNames: $page.url.pathname === urls.ABOUT.OUR_MISSION ? 'selected' : ''
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.header.about.blog'),
					href: urls.ABOUT.BLOG
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.header.about.contact'),
					href: urls.ABOUT.CONTACT,
					classNames: $page.url.pathname === urls.ABOUT.CONTACT ? 'selected' : ''
				}
			}
		}
	];
</script>

<MainNavItemWithDropdown label={$t('nav.header.about.label')} subItems={items} {...props} />
